import axios from '../../axios'

// 新增省份算法
export const addAlgorithm = (data) => {
    return axios({
        url: '/api/data/wish/algorithm',
        method: 'POST',
        data
    })
}

// 获取省份算法详情
export const getAlgorithmInfo = (data) => {
    return axios({
        url: '/api/data/wish/algorithm/info',
        method: 'GET',
        data
    })
}

// 修改省份算法信息
export const editAlgorithm = (data) => {
    return axios({
        url: '/api/data/wish/algorithm',
        method: 'PUT',
        data
    })
}

// 删除省份算法信息
export const deleteAlgorithm = (data) => {
    return axios({
        url: '/api/data/wish/algorithm',
        method: 'DELETE',
        data
    })
}

// 根据信息综合搜索省份算法信息列表
export const getAlgorithmList = (data) => {
    return axios({
        url: '/api/data/wish/algorithm',
        method: 'GET',
        data
    })
}



// WEBPACK FOOTER //
// ./src/http/moudules/dataManage/algorithm.js